var _defs, _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgReport2(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "800px",
    height: "800px",
    viewBox: "0 0 50 50",
    "data-name": "Layer 1",
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".cls-1{fill:#231f20;}.cls-2{fill:#ff8e5a;}.cls-3{fill:#ffba50;}.cls-4{fill:#ffffff;}"))), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M40.911,9.207H29.234V5a.5.5,0,0,0-.5-.5H5a.5.5,0,0,0-.5.5c0,.006,0,.011,0,.017L4.5,36.2a4.59,4.59,0,0,0,4.524,4.582.149.149,0,0,0,.018,0H9.06c.01,0,.019,0,.029,0s.019,0,.029,0h11.65V45a.5.5,0,0,0,.5.5H45a.5.5,0,0,0,.5-.5l0-31.2A4.6,4.6,0,0,0,40.911,9.207Z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M5.5,36.2l0-30.7H28.234V9.207H17.583a.462.462,0,0,0-.1.01c-.1-.007-.2-.01-.3-.01a4.6,4.6,0,0,0-4.59,4.591s.086,22.266.086,22.406a3.591,3.591,0,0,1-3.56,3.586H9.06A3.592,3.592,0,0,1,5.5,36.2Z"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M11.918,39.79a4.567,4.567,0,0,0,1.76-3.586c0-.1-.086-22.41-.086-22.408a3.59,3.59,0,0,1,7.179,0l0,25.994Z"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M44.5,44.5H21.768l0-30.7a4.585,4.585,0,0,0-1.733-3.589H40.911A3.593,3.593,0,0,1,44.5,13.8Z"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M41.13,37.239H25.136a.5.5,0,0,0,0,1H41.13a.5.5,0,0,0,0-1Z"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M41.13,31.692H25.136a.5.5,0,0,0,0,1H41.13a.5.5,0,0,0,0-1Z"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M41.13,26.156H25.136a.5.5,0,0,0,0,1H41.13a.5.5,0,0,0,0-1Z"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M41.13,20.653H25.136a.5.5,0,0,0,0,1H41.13a.5.5,0,0,0,0-1Z"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M41.13,15.106H25.136a.5.5,0,0,0,0,1H41.13a.5.5,0,0,0,0-1Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgReport2);
export default __webpack_public_path__ + "static/media/report2.47b4dfc167490b2914c8a1248460260d.svg";
export { ForwardRef as ReactComponent };